"use client"

import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import axios from "axios"
import { baseUrl } from "../../config/baseUrl"
import empty from "../../assets/images/empty-box.png"
import Swal from "sweetalert2"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBell, faPlus, faEye, faImage, faEdit, faTrash, faCheck, faTimes, faSearch } from "@fortawesome/free-solid-svg-icons"
import { toast } from "react-toastify"

export default function NotificationList() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")

  useEffect(() => {
    fetchData()
  }, [])
  console.log("response", data);
  
  const fetchData = async () => {
    try {
      setLoading(true)
      const response = await axios.get(
        `http://localhost:3000/admin/banner/list`, {
        // `${baseUrl}/admin/banner/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      setData(response.data.data || response.data)
    } catch (error) {
      console.log("error", error)
    } finally {
      setLoading(false)
    }
  }

  const handleToggleStatus = async (Id, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    try {
      const response = await axios.put(
        // `http://localhost:3000/admin/banner/status/${Id}`, 
        `${baseUrl}/admin/banner/status/${Id}`,
        { status: newStatus },
        {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.status) {
      
        fetchData();
        toast.success("banner status changed!");
      } else {
        throw new Error(response.message || "Failed to update banner status");
      }
    } catch (error) {
      console.error("Error updating banner status:", error);
      toast.error("Failed to update banner status. Please try again.");
    }
  };


  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    })

    if (result.isConfirmed) {
      try {
        await axios.delete(
          // `http://localhost:3000/admin/banner/delete/${id}`, {
          `${baseUrl}/admin/banner/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        fetchData()
        Swal.fire("Deleted!", "baneer has been deleted.", "success")
      } catch (error) {
        Swal.fire("Error!", "Failed to delete banner.", "error")
      }
    }
  }

  // Filter notifications based on search term
//   const filteredNotifications = notifications.filter(
//     (notification) =>
//       notification.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       notification.message.toLowerCase().includes(searchTerm.toLowerCase()),
//   )

  const truncateText = (text, maxLength = 100) => {
    return text?.length > maxLength ? text.substring(0, maxLength) + "..." : text
  }

  return (
    <>
      <section className="main-sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="dashboard-title">
                <h4 className="dash-head">
                  <FontAwesomeIcon icon={faImage} className="me-2" />
                  Banners List
                </h4>
              </div>
              <div className="custom-bredcump">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Banner List
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="col-lg-6 d-flex justify-content-end align-items-start">
              <Link to="/banner-add" className="btn btn-for-add text-white">
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Add Banner
              </Link>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="cards">
                <div className="bus-filter">
                  <div className="row align-items-center">
                    <div className="col-lg-6">
                      <h5 className="card-title">All Banners ({data.length})</h5>
                    </div>
                  </div>
                </div>


                <div className="table-responsive custom-table">
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>Title</th>
                        <th>Banner Image</th>
                        <th>Banner Link</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="loading-spinner">
                            <div className="spinner"></div>
                          </td>
                        </tr>
                      ) : data.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="empty-state">
                            <img src={empty || "/placeholder.svg"} alt="No notifications" width="200px" />
                            <h4>No Banner found!</h4>
                            <p className="text-muted">
                              {searchTerm
                                ? "Try adjusting your search criteria"
                                : "Start by adding your first Banner"}
                            </p>
                          </td>
                        </tr>
                      ) : (
                        data.map((banner, i) => (
                          <tr key={banner?._id}>
                            <td>{i + 1}</td>
                            <td>{truncateText(banner?.title, 100)}</td>
                            <td>
                              <div className="notification-image">
                                <img
                                  src={
                                    banner.imageUrl
                                      // ? `http://localhost:3000${banner.imageUrl}`
                                      ? `${baseUrl}/${banner.imageUrl}`
                                      : "/logo.png?height=60&width=60"
                                  }
                                  alt={banner?.title}
                                  className="notification-image"
                                  style={{ width: '100px' }}
                                />
                              </div>
                            </td>
                            <td>
                                <a
                                    href={banner?.link || "#"}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="banner-link"
                                >
                                    {truncateText(banner?.link, 50)}
                                </a>
                            </td>
                           
                            <td>
                              <button
                                onClick={() => handleToggleStatus(banner?._id, banner?.status)}
                                className={`status-badge ${banner.status === "active" ? "status-active" : "status-inactive"
                                  }`}
                              >
                                {banner?.status === "active" ? (
                                  <>
                                    <FontAwesomeIcon icon={faCheck} className="me-1" />
                                    Active
                                  </>
                                ) : (
                                  <>
                                    <FontAwesomeIcon icon={faTimes} className="me-1" />
                                    Inactive
                                  </>
                                )}
                              </button>
                            </td>
                            <td>
                              <div className="action-buttons">
                                <Link to={`/banner/view/${banner?._id}`} className="action-btn view-btn">
                                  <FontAwesomeIcon icon={faEye} />
                                  <span className="tooltip-text">View</span>
                                </Link>
                                <Link to={`/banner/edit/${banner?._id}`} className="action-btn edit-btn">
                                  <FontAwesomeIcon icon={faEdit} />
                                  <span className="tooltip-text">Edit</span>
                                </Link>
                                <button
                                  className="action-btn delete-btn"
                                  onClick={() => handleDelete(banner?._id)}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                  <span className="tooltip-text">Delete</span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
